import React, { useState, useEffect } from "react";
import { ArrowLeft, PlusCircle, Eye, Edit, Trash2 } from "react-feather";
import { Link } from "react-router-dom";
import Table from "../../../core/pagination/datatable";
import TableTop from "../../../Components/UI/TableTop";
import {
  useCPFContributionQuery,
  useInsertCPFContributionMutation,
  useUpdateCPFContributionMutation,
} from "../../../AppQuries/master/CpfContribution/contributions";
import Loader from "../../../feature-module/loader/loader";
import { useTableSearch } from "../../../core/Operations/useTableSearch";
import { useForm, FormProvider } from "react-hook-form";
import Breadcrumbs from "core/breadcrumbs";
import CpfContributionModal from "Components/Modal/master/CpfContributionModal";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { all_routes } from "Router/all_routes";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import Error404 from "MainPages/ErrorPages/error404";
import ToastNotification from "Components/UI/ToastNotification";
import Can from "core/Operations/Can";
import { accessCodes } from "core/json/accessCode";
const CPFContribution = () => {
  const userData = useSelector(loggedInUser);
  const {
    data,
    isLoading,
    isError,
    error,
    refetch: GetItems,
  } = useCPFContributionQuery();
  const methods = useForm();
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const { mutate: addItem } = useInsertCPFContributionMutation();
  const { mutate: updateItem } = useUpdateCPFContributionMutation();
  const [selectedItem, setSelectedItem] = useState(null);
  const [message, setMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const ItemData = data?.data.map((d, _id) => ({
    id: _id + 1,
    ...d,
  }));

  const handleAddClick = () => {
    setSelectedItem(null);
    methods.reset({
      companyCode: userData.companyCode,
      contributionCode: 0,
      contributionName: "",
      isActive: true,
      createUser: userData.userName,
      createDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    });
    setShow(true);
  };

  const handleEditClick = (item) => {
    setSelectedItem(item);
    methods.reset({
      companyCode: item.companyCode,
      contributionCode: item.contributionCode,
      contributionName: item.contributionName,
      isActive: item.isActive,
      createUser: item.createUser,
      createDate: item.createDate,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    });
    setShow(true);
  };

  const onSubmit = async (payload) => {
    if (selectedItem) {
      updateItem(payload, {
        onSuccess: (data) => {
          if (data) {
            setMessage("Updated Successfully.");
            setShowSuccessToast(true);
            setSelectedItem(null);
            setShow(false);
            GetItems();
          } else {
            setMessage("Something went wrong.");
            setShowErrorToast(true);
          }
        },
        onError: (error) => {
          setMessage(error.message || "Something went wrong.");
          setShowErrorToast(true);
        },
      });
    } else {
      addItem(payload, {
        onSuccess: (data) => {
          if (data) {
            setMessage("Created Successfully.");
            setShowSuccessToast(true);
            setShow(false);
            GetItems();
          } else {
            setMessage(error.message || "Something went wrong.");
            setShowErrorToast(true);
          }
        },
        onError: (error) => {
          setMessage(error.message || "Something went wrong.");
          setShowErrorToast(true);
        },
      });
    }
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowErrorToast(false);
      setShowSuccessToast(false);
    }, 6000);
    return () => clearTimeout(timeoutId);
  }, [showErrorToast, showSuccessToast]);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const columns = [
    {
      title: "Code",
      dataIndex: "contributionCode",
      sorter: (a, b) => a.contributionCode.length - b.contributionCode.length,
    },

    {
      title: "Contribution Name",
      dataIndex: "contributionName",
      sorter: (a, b) => a.contributionName.length - b.contributionName.length,
    },

    {
      title: "Created User",
      dataIndex: "createUser",
      sorter: (a, b) => a.createUser.length - b.createUser.length,
    },

    {
      title: "Status",
      dataIndex: "isActive",
      render: (text) => (
        <>
          {text === true && (
            <div className="badges badge-linesuccess">Active</div>
          )}
          {text === false && (
            <div className="badges badge-linedanger">In Active</div>
          )}
        </>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
          <Can
            accessModule={accessCodes.master}
            accessCode={accessCodes.master_cpfcontribution}
            accessType="haveEdit"
          >
            <Link className="" onClick={() => handleEditClick(record)}>
              <Edit className="feather-edit" />
            </Link>
          </Can>
          &nbsp;
          {/* <Link
            className="confirm-text p-2"
            to="#"
            // onClick={}
          >
            <Trash2 className="feather-trash-2" />
          </Link> */}
        </div>
      ),
    },
  ];

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    data?.data,
    searchColumns
  );

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return <Error404 error={error} />;
  }

  return (
    <>
      <div className="toast-container position-fixed top-0 end-0 p-3">
        <ToastNotification
          showSuccessToast={showSuccessToast}
          showErrorToast={showErrorToast}
          message={message}
        />
      </div>
      <div className="page-wrapper">
        <div className="content">
          {/* <Breadcrumbs maintitle="Call History" subtitle="Manage your products" /> */}
          <div className="page-header">
            <div className="page-title">
              <h4>CPF Contributions List</h4>
              <h6>Manage Compnay CPF Contributions</h6>
              {/* <nav aria-label="breadcrumb">
                <ol className="breadcrumb breadcrumb-arrow mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/">
                      <i className="fas fa-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="..">Master</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    CPF Contributions
                  </li>
                </ol>
              </nav> */}
            </div>
            <div className="page-btn" style={{ display: "flex" }}>
              <Can
                accessModule={accessCodes.master}
                accessCode={accessCodes.master_cpfcontribution}
                accessType="haveAdd"
              >
                <Link to="#" className="btn btn-added" onClick={handleAddClick}>
                  <PlusCircle className="me-2" />
                  Add New CPF Contribution
                </Link>
              </Can>
              &nbsp;
              <Link to={`${all_routes.master}`} className="btn btn-secondary">
                <i className="fas fa-reply me-2"></i>
                Back
              </Link>
            </div>
          </div>

          <div className="card table-list-card border-0">
            <div className="card-body">
              <TableTop
                onSearch={setSearchValue}
                toggleFilterVisibility={toggleFilterVisibility}
                isFilterVisible={isFilterVisible}
              />

              <div className="table-responsive">
                <Table
                  className="table  datanew"
                  columns={columns}
                  dataSource={filteredData}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <FormProvider {...methods}>
        <CpfContributionModal
          mode={selectedItem ? "E" : "I"}
          onSubmit={onSubmit}
          show={show}
          handleClose={handleClose}
        />
      </FormProvider>
    </>
  );
};

export default CPFContribution;
